const styles = {
  rowStyles: {
    gap: '48px',
    alignItems: 'flex-start'
  }
}
export { styles }
